import Shared from "emun.cart/cart.controller";
import resolve from "ioc/resolve";
import templateUrl from "emun.cart/cart-auto-print.htm";

class CartAutoPrintController extends Shared {
  constructor($cart) {
    super($cart);
    const $ctrl = this;
    $ctrl.$cart.bus.send("QueryPrinters.json").then((res) => {
      $ctrl.printers = res.data.results.map((o) => o.printerName);
    });
  }

}

let CartAutoPrint = {
  controller: CartAutoPrintController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};

export default CartAutoPrint;
